<template>
  <v-container fluid>
    <template>
      <v-card :loading="loading">
        <v-card-title>
          <h2>
            <v-btn
              class="mx-2"
              icon
              text
              small
              :to="{ name: 'unidade-medida-list', path: 'lista' }"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <span v-if="loading">Carregando...</span>
            <template v-else>
              <span v-if="tituloNovo">Nova unidade de medida</span>
              <span v-else>Alterar unidade de medida: {{descricao}}</span>
            </template>
          </h2>
        </v-card-title>
        <form @submit.prevent="submitForm">
          <v-card-text>
            <v-text-field
              v-model="codigo"
              :error-messages="codigoErrors"
              :counter="3"
              label="Código"
              required
              @input="$v.codigo.$touch()"
              @blur="$v.codigo.$touch()"
            ></v-text-field>
            <v-text-field
              v-model="descricao"
              :error-messages="descricaoErrors"
              :counter="50"
              label="Descrição"
              required
              @input="$v.descricao.$touch()"
              @blur="$v.descricao.$touch()"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn depressed color="primary" @click="submit" :loading="loading">Salvar</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </template>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],

  validations: {
    codigo: { required, maxLength: maxLength(3) },
    descricao: { required, maxLength: maxLength(50) }
  },

  data() {
    return {
      id: "",
      descricao: "",
      codigo: "",
      loading: false,
      tituloNovo: true
    };
  },

  computed: {
    descricaoErrors() {
      const errors = [];
      if (!this.$v.descricao.$dirty) return errors;
      !this.$v.descricao.maxLength && errors.push("Somente 50 caracteres.");
      !this.$v.descricao.required && errors.push("Descrição é Obrigatório.");
      return errors;
    },
    codigoErrors() {
      const errors = [];
      if (!this.$v.codigo.$dirty) return errors;
      !this.$v.codigo.maxLength && errors.push("Somente 3 caracteres.");
      //!this.$v.codigo.numeric && errors.push("Somente número");
      !this.$v.codigo.required && errors.push("Código é Obrigatório.");
      return errors;
    }
  },

  methods: {
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loading = true;
        const success = await this.$store.dispatch("unidadeMedida/gravar", {
          id: this.id,
          descricao: this.descricao,
          codigo: this.codigo
        });
        this.loading = false;
        if (success) {
          this.$router.replace({ path: "lista", name: "unidade-medida-list" });
        }
      }
    }
  },
  async mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Cadastro de unidades de medida"
    });
    this.loading = true;
    if (this.$route.params.id) {
      var id = this.$route.params.id;
      this.id = id;
      this.tituloNovo = false;

      try {
        var response = await this.$store.dispatch(
          "unidadeMedida/carregarUnidadeMedida",
          id
        );
        this.descricao = response.data.descricao;
        this.codigo = response.data.codigo;
        //this.preloader = false;
      } catch (err) {
        //deu pau
      }
    }
    this.loading = false;
  }
};
</script>
